import React, { useEffect, useState } from 'react';
import AppBar from '../Global/AppBar';
import NavBar from '../Global/NavBar';
import FlashLoader from '../FlashLoader';

interface PageProps {
  classes?: string;
  type?: string;
  isLoading?: boolean;
}

const Page: React.FC<PageProps & { children: React.ReactNode }> = ({
  classes,
  type,
  isLoading,
  children,
}) => {
  const [artificialLoading, setArtificialLoading] = useState(true);

  useEffect(() => {
    const id = window.setTimeout(() => {
      setArtificialLoading(false);
    }, 225);

    return () => window.clearTimeout(id);
  }, []);

  return (
    <div
      className={`page ${type ? 'page--' + type : ''} ${classes ? classes : ''}`}
    >
      <NavBar />
      <div className="page_content">{children}</div>
      <AppBar />
      <FlashLoader visible={isLoading ?? artificialLoading} />
    </div>
  );
};

export default Page;
